export default "https://assets.stage.yurplan.com/yurplan-v1/dist/eye-visible.bd1b9201be2eea02b0fadea10af777d3.svg";